import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Plus, Trash2 } from 'lucide-react';
import PropTypes from 'prop-types';

import classes from '@/orderForm/fields/Services/style.module.scss';
import ServiceIcon from '@/svg-icons/service';

class Services extends Component {
  constructor(props) {
    super(props);
    const services = props.formData?.length > 0
      ? [...props.formData]
      : [
          {
            type: '',
            responsibleEmail: '',
          },
        ];
    this.state = {
      services,
    };
    props.onChange(services);
  }

  // Handle value changes for service fields
  onChange = (propertyName, index) => {
    const { onChange } = this.props;
    return event => {
      const services = [...this.state.services];
      services[index][propertyName] = event.target.value;
      this.setState({ services });
      onChange(services);
    };
  };

  // Add a new service entry
  handleAddClick = () => {
    const { onChange } = this.props;
    const services = [...this.state.services, { type: '', responsibleEmail: '' }];
    this.setState({ services });
    onChange(services);
  };

  // Remove a service entry
  handleDeleteClick = index => () => {
    const { onChange } = this.props;
    let services = [...this.state.services];
    if (services.length === 1) {
      services[0] = { type: '', responsibleEmail: '' };
    } else {
      services.splice(index, 1);
    }
    this.setState({ services });
    onChange(services);
  };

  // Check if first service is empty
  isDisabled = () => {
    const { services } = this.state;
    return (
      services.length === 1 &&
      (!services[0].type || services[0].type === '') &&
      (!services[0].responsibleEmail || services[0].responsibleEmail === '')
    );
  };

  render() {
    const { services } = this.state;
    const { name } = this.props;

    return (
      <div className={`${classes.rootContainer || ''} w-full`}>
        <div className="w-full">
          {services &&
            services.map((service, index) => (
              <div className={classes.service} key={`service-${index}`}>
                <div className={classes.flexHeader}>
                  <p className={classes.title}>
                    <ServiceIcon viewBox="0 0 34.016 34.016" />
                    <span>
                      <FormattedMessage id={name} />
                      {` ${index + 1}`}
                    </span>
                  </p>
                  <button
                    type="button"
                    disabled={this.isDisabled()}
                    className={`${classes.removeButton} ${this.isDisabled() ? classes.removeButtonDisabled : ''}`}
                    onClick={this.handleDeleteClick(index)}
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
                <div>
                  <div className={classes.field}>
                    <label className={classes.label || 'label'} htmlFor={`field-type-${index}`}>
                      <FormattedMessage id="SERVICES.TYPE" />*
                    </label>
                    <input
                      className="form-control"
                      id={`field-type-${index}`}
                      type="text"
                      value={service.type || ''}
                      onChange={this.onChange('type', index)}
                    />
                  </div>
                  <div className={classes.field}>
                    <label className={classes.label || 'label'} htmlFor={`field-email-${index}`}>
                      <FormattedMessage id="recipients.email" />*
                    </label>
                    <input
                      className="form-control"
                      id={`field-email-${index}`}
                      type="email"
                      value={service.responsibleEmail || ''}
                      onChange={this.onChange('responsibleEmail', index)}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className={classes.grayLines}>
          <button
            type="button"
            className={classes.plusButton}
            onClick={this.handleAddClick}
          >
            <Plus size={14} />
          </button>
        </div>
      </div>
    );
  }
}

Services.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      responsibleEmail: PropTypes.string,
    })
  ),
};

Services.defaultProps = {
  formData: [],
};

// Use forwardRef is false because the original code had it true but didn't seem to use it for anything specific
// and injectIntl is standard here.
export default injectIntl(Services);
